import { observer } from "mobx-react-lite";
import { useTranslation } from "react-i18next";
import BriaSlider from "../../../../../../components/common/BriaSlider/BriaSlider";
import { useAppStore } from "../../../../../../hooks/useStores";
import InputLayout from "../../../../../../layout/InputLayout/InputLayout";

const TextToImageGuidance = () => {
	const { t } = useTranslation("image_generation", { keyPrefix: "playground.textToImage.config.textGuidanceScale" });
	const { textToImageStore } = useAppStore();

	const isFast = textToImageStore.config.fast;
	const value = textToImageStore.config.text_guidance_scale ?? 5.0;

	return (
		<InputLayout label={t("label")} info={t("info")}>
			<BriaSlider
				value={value}
				onChange={(_, v) => textToImageStore.handleConfigChange("text_guidance_scale", v as number)}
				step={0.1}
				min={1.0}
				max={10.0}
				disabled={isFast || false}
				disabledTooltip={t("disabledTooltip")}
				marks={[
					{ value: 1.0, label: "1" },
					{ value: 5.0, label: "5" },
					{ value: 10.0, label: "10" },
				]}
				valueLabelDisplay="auto"
			/>
		</InputLayout>
	);
};

export default observer(TextToImageGuidance);
